import React, { useState, useEffect } from 'react';
import { FiSave, FiDollarSign, FiPercent, FiCreditCard } from 'react-icons/fi';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const SystemSettings = () => {
  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState({
    commission: {
      percentage: 10,
      type: 'percentage'
    },
    subscription: {
      enabled: true,
      plans: []
    },
    payment: {
      razorpayEnabled: true,
      codEnabled: true
    }
  });

  const handleSaveSettings = async () => {
    setLoading(true);
    try {
      // API call to save settings would go here
      toast.success('Settings saved successfully');
    } catch (error) {
      toast.error('Failed to save settings');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="system-settings-page">
      <div className="page-header">
        <h1>System Settings</h1>
        <p>Configure platform settings and commission rates</p>
      </div>

      {/* Commission Settings */}
      <div className="settings-section">
        <div className="settings-card">
          <div className="settings-card-header">
            <FiPercent className="settings-icon" />
            <h2>Commission Settings</h2>
          </div>
          <div className="settings-card-body">
            <div className="form-group">
              <label>Commission Type</label>
              <select 
                className="form-control"
                value={settings.commission.type}
                onChange={(e) => setSettings({
                  ...settings,
                  commission: { ...settings.commission, type: e.target.value }
                })}
              >
                <option value="percentage">Percentage</option>
                <option value="fixed">Fixed Amount</option>
              </select>
            </div>

            <div className="form-group">
              <label>
                {settings.commission.type === 'percentage' 
                  ? 'Commission Percentage (%)' 
                  : 'Fixed Commission Amount (₹)'}
              </label>
              <input
                type="number"
                className="form-control"
                value={settings.commission.percentage}
                onChange={(e) => setSettings({
                  ...settings,
                  commission: { ...settings.commission, percentage: e.target.value }
                })}
                min="0"
                max={settings.commission.type === 'percentage' ? '100' : undefined}
              />
            </div>

            <div className="info-box">
              <p>
                <strong>Current Commission:</strong> 
                {settings.commission.type === 'percentage' 
                  ? ` ${settings.commission.percentage}% of order value`
                  : ` ₹${settings.commission.percentage} per order`}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Subscription Settings */}
      <div className="settings-section">
        <div className="settings-card">
          <div className="settings-card-header">
            <FiCreditCard className="settings-icon" />
            <h2>Subscription Settings</h2>
          </div>
          <div className="settings-card-body">
            <div className="form-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={settings.subscription.enabled}
                  onChange={(e) => setSettings({
                    ...settings,
                    subscription: { ...settings.subscription, enabled: e.target.checked }
                  })}
                />
                <span>Enable Subscription Plans</span>
              </label>
            </div>

            {settings.subscription.enabled && (
              <div className="info-box">
                <p>Vendors can subscribe to different plans for additional features.</p>
                <button 
                  className="btn btn-secondary"
                  onClick={() => window.location.href = '/superadmin/subscription-plans'}
                >
                  Manage Subscription Plans
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Payment Settings */}
      <div className="settings-section">
        <div className="settings-card">
          <div className="settings-card-header">
            <FiDollarSign className="settings-icon" />
            <h2>Payment Settings</h2>
          </div>
          <div className="settings-card-body">
            <div className="form-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={settings.payment.razorpayEnabled}
                  onChange={(e) => setSettings({
                    ...settings,
                    payment: { ...settings.payment, razorpayEnabled: e.target.checked }
                  })}
                />
                <span>Enable Razorpay Payment Gateway</span>
              </label>
            </div>

            <div className="form-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={settings.payment.codEnabled}
                  onChange={(e) => setSettings({
                    ...settings,
                    payment: { ...settings.payment, codEnabled: e.target.checked }
                  })}
                />
                <span>Enable Cash on Delivery (COD)</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Platform Settings */}
      <div className="settings-section">
        <div className="settings-card">
          <div className="settings-card-header">
            <h2>Platform Settings</h2>
          </div>
          <div className="settings-card-body">
            <div className="form-group">
              <label>Platform Name</label>
              <input
                type="text"
                className="form-control"
                defaultValue="HUKAM MERE AAKA"
                placeholder="Platform Name"
              />
            </div>

            <div className="form-group">
              <label>Support Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="support@example.com"
              />
            </div>

            <div className="form-group">
              <label>Support Phone</label>
              <input
                type="tel"
                className="form-control"
                placeholder="+91 XXXXXXXXXX"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="settings-actions">
        <button 
          className="btn btn-primary btn-large"
          onClick={handleSaveSettings}
          disabled={loading}
        >
          <FiSave />
          {loading ? 'Saving...' : 'Save All Settings'}
        </button>
      </div>
    </div>
  );
};

export default SystemSettings;
